import React from 'react'
import { Link } from "react-router-dom";

export default function HomeLuxury() {
  return (
    <>
    <section className="banner-section">
        <div className="homebanner-text wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
            <h4 className='heading'>Luxury, Tailored to Perfection</h4>
            <Link to={"/contact"} className="default-btn">Consult Now</Link>
        </div>

        <img src="/image/luxury-banner.webp" className="img-responsive" alt="luxury" loading="lazy"/>
        <div className="banner-overlay"></div>
    </section> 
    </>
  )
}
